import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace, useNamespaceRoutes } from '@modules/permissions/composables';
import { usePermissionsStore } from '@modules/permissions/store';

import type {
  IAffiliateBalanceResponse,
} from '../types';
import {
  AFF_BALANCES_PERMISSIONS,
  AFFILIATE_BALANCE_QUERY_KEY,
  AFFILIATE_BALANCE_URL,
} from '../constants';

export default function useAffiliateBalanceQuery(): IContextQueryResult<
  IAffiliateBalanceResponse,
  Error,
  number
> {
  const { fetchGet } = useRestClient();
  const { isAffiliateNamespace } = useCurrentNamespace();
  const { isAffiliateRoute } = useNamespaceRoutes();
  const { hasPermission } = usePermissionsStore();

  return useContextQuery<
    IAffiliateBalanceResponse,
    Error,
    number
  >({
    queryKey: [AFFILIATE_BALANCE_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateBalanceResponse>(
      AFFILIATE_BALANCE_URL,
      {
        signal,
        permission: AFF_BALANCES_PERMISSIONS.SHOW_BALANCE,
      },
    ),
    staleTime: 5000,
    select: (data) => data.balance,
    enabled: computed(() => isAffiliateNamespace.value && isAffiliateRoute.value && hasPermission(AFF_BALANCES_PERMISSIONS.SHOW_BALANCE).value),
  });
}
